<template>
  <ModalLayout
    :id="id"
    v-model="openModalComputed"
    @click:cancel="handleCancelEdit"
    @click:save="handleSaveEdit"
  >
    <div class="flex flex-col">
      <h2 class="text-xl mb-4">แก้ไขสมาชิก {{ selectingNameComputed }}</h2>

      <fieldset class="flex items-center mb-2">
        <label class="flex-shrink-0 mr-2 w-1/5">เปลี่ยนสมาชิก</label>
        <v-select
          data-test="people-selector"
          id="people-selector"
          class="w-full"
          placeholder="กรุณาเลือกสมาชิก"
          :options="peopleOptionsComputed"
          label="label"
          :clearable="false"
          :reduce="(person) => person.value"
          v-model="changeMember"
        >
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
          </template>
        </v-select>
      </fieldset>

      <fieldset class="flex items-center mb-2">
        <label class="flex-shrink-0 mr-2 w-1/5">เปลี่ยนความสัมพันธ์</label>
        <v-select
          data-test="relation-selector"
          id="relation-selector"
          class="w-full"
          placeholder="กรุณาความสัมพันธ์"
          :options="relationOptions"
          :clearable="false"
          v-model="changeRelation"
        >
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
          </template>
        </v-select>
      </fieldset>
    </div>
  </ModalLayout>
</template>

<script setup>
import { computed, watch, ref } from "vue";
import ModalLayout from "../base/modal-layout/ModalLayout.vue";
import { RELARION_OPTION } from "./static/data";

const props = defineProps({
  modelValue: Boolean,
  id: String,
  selecting: {
    type: Object,
    default: null,
  },
  peopleOptions: { type: Array, default: () => [] },
});
const emits = defineEmits(["update:modelValue", "saveEdit", "cancelEdit"]);

const changeMember = ref(null);
const changeRelation = ref(null);

const openModalComputed = computed({
  get() {
    return props.modelValue;
  },
  set(evt) {
    emits("update:modelValue", evt);
  },
});

const peopleOptionsComputed = computed(() => {
  return props.peopleOptions;
});

const selectingNameComputed = computed(() => {
  if (props.selecting) {
    let nodedata = props.selecting.data.data;
    if (nodedata.source) {
      return `${nodedata.source.title}${nodedata.source.name} และ ${nodedata.target.title}${nodedata.target.name}`;
    }
    return `${nodedata.title}${nodedata.name}`;
  }
  return "";
});

const relationOptions = computed(() => {
  let result = RELARION_OPTION;
  if (!props.selecting) return [];
  if (props.selecting.data.relation_node)
    return result.filter(
      (item) =>
        ![
          "คู่สมรส",
          "บิดา",
          "มารดา",
          "ลุง",
          "ป้า",
          "น้า",
          "อา",
          "พ่อ",
          "แม่",
          "พี่",
          "น้อง",
          "ปู่",
          "ย่า",
          "ตา",
          "ยาย",
          "ญาติพี่น้อง",
        ].includes(item)
    );
  if (changeMember.value) {
    if (changeMember.value.sex === "ชาย") {
      result = result.filter(
        (item) => !["มารดา", "ย่า", "ยาย", "ป้า"].includes(item)
      );
    } else if (changeMember.value.sex === "หญิง") {
      result = result.filter(
        (item) => !["บิดา", "ปู่", "ตา", "ลุง"].includes(item)
      );
    }
  } else {
    if (props.selecting.data.sex === "ชาย") {
      result = result.filter(
        (item) => !["มารดา", "ย่า", "ยาย", "ป้า"].includes(item)
      );
    } else if (props.selecting.data.sex === "หญิง") {
      result = result.filter(
        (item) => !["บิดา", "ปู่", "ตา", "ลุง"].includes(item)
      );
    }
  }
  return result;
});

const handleCancelEdit = () => {
  emits("cancelEdit");
  changeMember.value = null;
  changeRelation.value = null;
};
const handleSaveEdit = () => {
  let tempMember = null;
  if (changeMember.value) {
    tempMember = {
      name: changeMember.value.name,
      sex: changeMember.value.sex,
      surname: changeMember.value.surname,
      title: changeMember.value.title,
      _id: changeMember.value._id,
    };
  }
  emits("saveEdit", tempMember, changeRelation.value);
  changeMember.value = null;
  changeRelation.value = null;
};
</script>
